import { render, staticRenderFns } from "./calendar-facet-bar-color.vue?vue&type=template&id=37489c98&"
import script from "./calendar-facet-bar-color.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-bar-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports